export default "__VITE_ASSET__DjgO3$DH__"